// extracted by mini-css-extract-plugin
var _1 = "CommentEdit_editor__EepnD";
export { _1 as "editor" }
